import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellTree, TTableOptions, TTableRowNode } from '../../table.type';

type TChatUiTableModelData = { [key: string]: number | string }[];
type TChatUiTableModelHeaders = string[];

export const AI_ANALYTICS_TABLE_MODEL = {
  createModel: function (headerInfo: TChatUiTableModelHeaders, data: TChatUiTableModelData) {
    if (!headerInfo) {
      headerInfo = Object.keys(data[0]);
    }
    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: getHeaderConfig(headerInfo),
      },
      (el: TChatUiTableModelData[number]): TTableRowNode<TChatUiTableModelData[number]> => {
        return {
          type: 'ROW',
          rowItem: el,
          cells: getRowCells(headerInfo, el),
        };
      },
    );
  },
};

function getHeaderConfig(headerInfo: TChatUiTableModelHeaders): TTableOptions['headerConfig'] {
  return headerInfo.map<TTableOptions['headerConfig'][number]>((header) => ({
    type: 'TEXT_CELL',
    text: header,
    widthInPx: 150,
  }));
}

function getRowCells(headerInfo: TChatUiTableModelHeaders, rowItem: TChatUiTableModelData[number]): TTableCellTree[] {
  return headerInfo.map<TTableCellTree>((header) => ({
    type: 'TEXT_CELL',
    text: rowItem[header],
    widthInPx: 150,
  }));
}
